"use client";

import { useEffect, useState } from "react";

import { CurrencyCalculatorDialog } from "@/components/currency/currency-calculator-dialog";

// Mandatory when a page is served from the SW's page cache while offline —
// without this, stale cached content could be mistaken for a live view.
export function OfflineBanner() {
  const [isOffline, setIsOffline] = useState(false);

  useEffect(() => {
    setIsOffline(!navigator.onLine);
    const goOnline = () => setIsOffline(false);
    const goOffline = () => setIsOffline(true);
    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
    };
  }, []);

  if (!isOffline) return null;

  return (
    <div className="flex flex-wrap items-center justify-center gap-3 bg-amber-100 px-4 py-2 text-center text-sm text-amber-900 print:hidden dark:bg-amber-900/40 dark:text-amber-100">
      <span>📡 오프라인 — 마지막으로 본 내용을 표시 중이에요. 입력은 연결 후 가능해요.</span>
      <CurrencyCalculatorDialog
        trigger={
          <button
            type="button"
            className="inline-flex items-center gap-1 rounded border border-amber-300 bg-amber-50 px-2 py-0.5 text-xs font-medium text-amber-900 transition-colors hover:bg-amber-200 dark:border-amber-700 dark:bg-amber-950 dark:text-amber-100 dark:hover:bg-amber-900"
          >
            환율 계산기 (오프라인 캐시)
          </button>
        }
      />
    </div>
  );
}

